import type { RootState } from 'state';
import { Duration } from '../constants/filtersKeys';

function isFetchingDurationInProgress(state: RootState): boolean {
  const { fetching } = state.flightCalendars.filtersOptions;
  return fetching.indexOf(Duration) !== -1;
}

export default isFetchingDurationInProgress;
